import * as React from "react"
import { useSetRecoilState, useRecoilValue } from "recoil"
import { v4 as uuidv4 } from "uuid"
import { Avatar } from "./Avatar"
import { genConfig } from "./utils"
import { Box, Flex } from "@chakra-ui/react"
import {
  avatarListConfigsAtom,
  avatarListConfigsSelector
} from "../../../../recoil/atoms/avatar"
import { ScrollMenu } from "react-horizontal-scrolling-menu"
import { RightArrow } from "./rightArrow"
import { LeftArrow } from "./leftArrow"
import useWindowSize from "../../../../hooks/useWindowSize"

export const AvatarList = ({ selectConfig, isSmallWidth, isLandscape }) => {
  const setAvatarConfigList = useSetRecoilState(avatarListConfigsSelector)
  const avatarConfigList = useRecoilValue(avatarListConfigsAtom)

  const genConfigList = React.useCallback((count: number) => {
    return new Array(count).fill(null).map(() => ({
      ...genConfig({ isGradient: Boolean(Math.round(Math.random())) }),
      id: "n_" + uuidv4()
    }))
  }, [])

  React.useEffect(() => {
    const data = genConfigList(60)
    setAvatarConfigList({ type: "DOWNLOAD", payload: data })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { screenSize } = useWindowSize()

  return (
    <Box
      id="avatarList"
      width={isSmallWidth ? "16rem" : "37rem"}
      pos="relative"
      marginTop="auto"
      paddingLeft={screenSize.width < 350 && "1.5rem"}
      paddingRight={screenSize.width < 350 && "1.5rem"}
      paddingTop={isLandscape ? "0.2rem" : "0.75rem"}
      paddingBottom={isLandscape ? "0.2rem" : "0.75rem"}
    >
      <ScrollMenu
        LeftArrow={<LeftArrow isLandscape={isLandscape} />}
        RightArrow={<RightArrow isLandscape={isLandscape} />}
      >
        {avatarConfigList.map((item, idx) => {
          return (
            <Flex
              key={item.id}
              itemId={`Avatar-${item.id}`} // NOTE: itemId is required for track items
              className="AvatarItemWrapper"
              flex="0 0 3.7rem"
              height="3.7rem"
              alignItems="center"
              justifyContent="center"
              marginRight="10px"
              onClick={() => selectConfig(item)}
            >
              <Avatar
                style={{
                  width:
                    isLandscape || screenSize.width < 350 ? "40px" : "50px",
                  height:
                    isLandscape || screenSize.width < 350 ? "40px" : "50px"
                }}
                {...item}
              />
            </Flex>
          )
        })}
      </ScrollMenu>
    </Box>
  )
}
